import { render, staticRenderFns } from "./DailyStatsDataTable.vue?vue&type=template&id=0313cd46&"
import script from "./DailyStatsDataTable.vue?vue&type=script&lang=js&"
export * from "./DailyStatsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports